export default "__VITE_ASSET__BdImqUt9__"